<template>
  <div>
    <el-form
      @submit.native.prevent
      class="cml-search-form"
      ref="listForm"
      :model="listForm"
      :inline="true"
      label-width="100px"
      size="mini"
    >
      <el-row>
        <el-form-item label="产品名称" prop="productName">
          <el-input
            v-model.trim="listForm.productName"
            clearable
            @keyup.13.native="onSearch"
          />
        </el-form-item>
        <el-form-item
          label="供应商"
          v-if="$store.getters.userSupplier.customerId === '0'"
          prop="supplierCodeList"
        >
          <SupplierSelect
            multiple
            :value="listForm.supplierCodeList"
            @change-emit="val => (listForm.supplierCodeList = val)"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="primary" @click="onReset">清空</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="cml-button-group cml-tab-button-group">
      <el-tabs type="card" v-model="selectTab" @tab-click="tabChange">
        <el-tab-pane type="text" name="Tab1" label="全部"></el-tab-pane>
        <el-tab-pane type="text" name="Tab2" label="已上架"></el-tab-pane>
        <el-tab-pane type="text" name="Tab3" label="已下架"></el-tab-pane>
      </el-tabs>
      <div class="cml-tabs-btn-group">
        <el-button
          v-if="selectTab !== 'Tab2'"
          size="mini"
          :disabled="btnDisabled"
          :loading="onLoading"
          v-hasPermission="'sample-manage/sample-list-put-on-batch'"
          @click="batchOperation('on', '上架')"
          >批量上架</el-button
        >
        <el-button
          v-if="selectTab !== 'Tab3'"
          size="mini"
          :disabled="btnDisabled"
          :loading="offLoading"
          v-hasPermission="'sample-manage/sample-list-put-off-batch'"
          @click="batchOperation('off', '下架')"
          >批量下架</el-button
        >
      </div>
    </div>

    <div v-show="selectTab === 'Tab1'">
      <CommonTable
        ref="CommonTableRefTab1"
        :loading="tableLoading"
        :tableHead="tableHeadTab1"
        :tableData="tableDataTab1"
        :tableParam="tableParamTab1"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.sampleVO.mainImage && row.type !== 'RAW_MATERIAL'"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.sampleVO.mainImage + $ImgQuality30"
              :preview-src-list="[row.sampleVO.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>

        <template #shuiyangSlot="{ row }">
          <span v-if="row.sampleVO.shuiyangEnable === 'YES'">是</span>
          <span v-if="row.sampleVO.shuiyangEnable === 'NO'">否</span>
          <el-popover
            placement="top"
            width="280"
            trigger="click"
            @show="popoverShow(row.id)"
            v-model="row.popoverStatus"
          >
            <div class="shuiyang-popover">
              <span>是否被水羊启用过</span>
              <el-radio-group v-model="row.isShuiyang">
                <el-radio label="YES">是</el-radio>
                <el-radio label="NO">否</el-radio>
              </el-radio-group>
              <div class="btns">
                <el-button @click="row.popoverStatus=false">取消</el-button>
                <el-button type="primary" @click="updateShuiyangStatus(row, row.isShuiyang)">确认</el-button>
              </div>
            </div>
            <el-button
              style="margin-left: 10px;"
              slot="reference"
              type="text"
              v-if="row.sampleVO.shuiyangEnable"
              v-hasPermission="'sample-manage/sample-list-copy'"
            >修改</el-button>
          </el-popover>
        </template>

        <template #operationSlot="{ row }">
          <el-button
            v-if="['TAKE_OFF'].includes(row.status) && ['GIFT_MATERIAL'].includes(row.type)"
            v-hasPermission="'sample-manage/sample-list- on-line-update'"
            @click="editBtn(row)"
            type="text"
          >修改</el-button>
          <el-button
            v-if="['TAKE_OFF'].includes(row.status)"
            v-hasPermission="'sample-manage/sample-list-put-on'"
            @click="batchOperation('on', '上架', row)"
            type="text"
          >上架</el-button>
          <el-button
            v-if="['PUT_ON'].includes(row.status)"
            @click="batchOperation('off', '下架', row)"
            v-hasPermission="'sample-manage/sample-list-put-off'"
            type="text"
          >下架</el-button>
          <el-button
            type="text"
            v-hasPermission="'sample-manage/sample-list-copy'"
            @click="copySample(row)"
          >复制</el-button>
        </template>
      </CommonTable>
    </div>

    <div v-show="selectTab === 'Tab2'">
      <CommonTable
        ref="CommonTableRefTab2"
        :loading="tableLoading"
        :tableHead="tableHeadTab2"
        :tableData="tableDataTab2"
        :tableParam="tableParamTab2"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.sampleVO.mainImage && row.type !== 'RAW_MATERIAL'"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.sampleVO.mainImage + $ImgQuality30"
              :preview-src-list="[row.sampleVO.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>

        <template #shuiyangSlot="{ row }">
          <span v-if="row.sampleVO.shuiyangEnable === 'YES'">是</span>
          <span v-if="row.sampleVO.shuiyangEnable === 'NO'">否</span>
          <el-popover
            placement="top"
            width="280"
            trigger="click"
            @show="popoverShow(row.id)"
            v-model="row.popoverStatus"
          >
            <div class="shuiyang-popover">
              <span>是否被水羊启用过</span>
              <el-radio-group v-model="row.isShuiyang">
                <el-radio label="YES">是</el-radio>
                <el-radio label="NO">否</el-radio>
              </el-radio-group>
              <div class="btns">
                <el-button @click="row.popoverStatus=false">取消</el-button>
                <el-button type="primary" @click="updateShuiyangStatus(row, row.isShuiyang)">确认</el-button>
              </div>
            </div>
            <el-button
              style="margin-left: 10px;"
              slot="reference"
              type="text"
              v-if="row.sampleVO.shuiyangEnable"
              v-hasPermission="'sample-manage/sample-list-copy'"
            >修改</el-button>
          </el-popover>
        </template>

        <template #operationSlot="{ row }">
          <el-button
            @click="batchOperation('off', '下架', row)"
            v-hasPermission="'sample-manage/sample-list-put-off'"
            type="text"
          >下架</el-button>
          <el-button
            type="text"
            v-hasPermission="'sample-manage/sample-list-copy'"
            @click="copySample(row)"
          >复制</el-button>
        </template>
      </CommonTable>
    </div>

    <div v-show="selectTab === 'Tab3'">
      <CommonTable
        ref="CommonTableRefTab3"
        :loading="tableLoading"
        :tableHead="tableHeadTab3"
        :tableData="tableDataTab3"
        :tableParam="tableParamTab3"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.sampleVO.mainImage && row.type !== 'RAW_MATERIAL'"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.sampleVO.mainImage + $ImgQuality30"
              :preview-src-list="[row.sampleVO.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>

        <template #shuiyangSlot="{ row }">
          <span v-if="row.sampleVO.shuiyangEnable === 'YES'">是</span>
          <span v-if="row.sampleVO.shuiyangEnable === 'NO'">否</span>
          <el-popover
            placement="top"
            width="280"
            trigger="click"
            @show="popoverShow(row.id)"
            v-model="row.popoverStatus"
          >
            <div class="shuiyang-popover">
              <span>是否被水羊启用过</span>
              <el-radio-group v-model="row.isShuiyang">
                <el-radio label="YES">是</el-radio>
                <el-radio label="NO">否</el-radio>
              </el-radio-group>
              <div class="btns">
                <el-button @click="row.popoverStatus=false">取消</el-button>
                <el-button type="primary" @click="updateShuiyangStatus(row, row.isShuiyang)">确认</el-button>
              </div>
            </div>
            <el-button
              style="margin-left: 10px;"
              slot="reference"
              type="text"
              v-if="row.sampleVO.shuiyangEnable"
              v-hasPermission="'sample-manage/sample-list-copy'"
            >修改</el-button>
          </el-popover>
        </template>

        <template #operationSlot="{ row }">
          <el-button
            v-hasPermission="'sample-manage/sample-list- on-line-update'"
            @click="editBtn(row)"
            type="text"
          >修改</el-button>
          <el-button
            @click="batchOperation('on', '上架', row)"
            v-hasPermission="'sample-manage/sample-list-put-on'"
            type="text"
          >上架</el-button>
          <el-button
            type="text"
            v-hasPermission="'sample-manage/sample-list-copy'"
            @click="copySample(row)"
          >复制</el-button>
        </template>
      </CommonTable>

      <!-- 批量操作后的弹窗 -->
      <el-dialog
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="resultDialogVisible"
      >
        <ResultDialog
          :dialogResult="dialogResult"
          :tableDataField="'failResultList'"
        />
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="resultDialogVisible = false"
            size="mini"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import SupplierSelect from '@/components/SupplierSelect';
import ResultDialog from '@/components/ResultDialog';
import CommonTable from '@/components/CommonTable';
import sampleMixin from '@/mixins/sampleMixin';

export default {
  components: {
    SupplierSelect,
    ResultDialog,
    CommonTable,
  },
  mixins: [sampleMixin],
  props: {},
  data() {
    return {
      listForm: {
        productName: '',
        supplierCodeList: [],
      },
      selectTab: 'Tab2',
      tableLoading: false,
      tableParamTab1: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableParamTab2: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableParamTab3: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      status: {
        Tab1: ['PUT_ON', 'TAKE_OFF'],
        Tab2: ['PUT_ON'],
        Tab3: ['TAKE_OFF'],
      },
      tableHeadTab1: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        { label: '供应商', prop: 'supplierName' },
        { label: '状态', prop: 'statusName', width: 150 },
        { label: '是否被水羊启用过', prop: 'shuiyang', width: 120, slotColumn: true, slotName: 'shuiyangSlot' },
        { label: '创建时间', prop: 'createDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableHeadTab2: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        { label: '供应商', prop: 'supplierName' },
        { label: '状态', prop: 'statusName', width: 150 },
        { label: '是否被水羊启用过', prop: 'shuiyang', width: 120, slotColumn: true, slotName: 'shuiyangSlot' },
        { label: '创建时间', prop: 'createDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableHeadTab3: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        { label: '供应商', prop: 'supplierName' },
        { label: '状态', prop: 'statusName', width: 150 },
        { label: '是否被水羊启用过', prop: 'shuiyang', width: 120, slotColumn: true, slotName: 'shuiyangSlot' },
        { label: '创建时间', prop: 'createDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableDataTab1: {},
      tableDataTab2: {},
      tableDataTab3: {},
      selectionTab1: [],
      selectionTab2: [],
      selectionTab3: [],
      onLoading: false,
      offLoading: false,
      dialogResult: {},
      resultDialogVisible: false,
      fit: 'contain',
    };
  },
  computed: {
    btnDisabled() {
      return this[`selection${this.selectTab}`].length < 1;
    },
  },
  watch: {
    selectTab() {
      this.getList();
    },
  },
  mounted() {
    const { category } = this.$store.getters.userSupplier;
    if(category === 'RAW_MATERIAL') {
      ['tableHeadTab1', 'tableHeadTab2', 'tableHeadTab3'].map(el => {
        this[el] = this[el].filter(item => item.prop !== 'shuiyang');
      })
    }
    this.$refs.CommonTableRefTab1.changeHeight(120);
    this.$refs.CommonTableRefTab2.changeHeight(120);
    this.$refs.CommonTableRefTab3.changeHeight(120);
    this.getList();
  },
  methods: {
    onSearch() {
      this[`tableParam${this.selectTab}`].pageNo = 1;
      this.getList();
    },
    getList() {
      const params = {
        ...this[`tableParam${this.selectTab}`],
        data: this.listForm,
      };
      if (!params.orderBy) {
        params.orderBy = 'create_date desc';
      }
      params.data.statusList = this.status[this.selectTab];
      this.tableLoading = true;
      this.$http.sampleManage
        .getSampleList(params)
        .then(result => {
          this[`tableData${this.selectTab}`] = {
            list: result.data.list.map(item => {
              item.sampleVO =
                item[this.filterParam(item.type).listDataParam] || [];
              return item;
            }),
            total: result.data.total,
          };
          this[`selection${this.selectTab}`] = [];
          this.$refs[`CommonTableRef${this.selectTab}`].clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    editBtn(row) {
      this.jumpUrl(row, 'update');
    },
    // 批量操作
    batchOperation(val, text, obj) {
      const selectData = obj ? [obj] : this[`selection${this.selectTab}`];
      if (val === 'on') {
        // 上架
        if (!selectData.every(item => item.status === 'TAKE_OFF')) {
          this.$message.error('请选择“已下架”的样品操作');
          return;
        }
      } else {
        // 下架
        if (!selectData.every(item => item.status === 'PUT_ON')) {
          this.$message.error('请选择“已上架”的样品操作');
          return;
        }
      }
      this.$confirm(`确认${text}所选的样品?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this[`${val}Loading`] = true;
        this.$http.sampleManage[`batchSamplePut${val}`](
          selectData.map(item => item.id),
        )
          .then(result => {
            if (result.data.failNum === 0) {
              this.$message.success(result.msg);
            } else {
              this.dialogResult = result.data;
              this.resultDialogVisible = true;
            }
            this.getList();
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this[`${val}Loading`] = false;
          });
      });
    },
    // 复制
    copySample(row) {
      this.$refs[`CommonTableRef${this.selectTab}`].$refs.vxeTable.closeTooltip();
      this.jumpUrl(row, 'copy', 'reload');
    },
    // 水羊启用状态
    popoverShow(id) {
      const data = this[`tableData${this.selectTab}`].list;
      const index = data.findIndex(item => item.id === id);
      this.$set(data[index], 'isShuiyang', data[index][this.filterParam(data[index].type).listDataParam].shuiyangEnable);
    },
    updateShuiyangStatus(row, val) {
      const params = `id=${row.id}&shuiYangEnable=${val}`
      this.$http.sampleManage
        .updateShuiyangEnable(params)
        .then(result => {
          this.$message.success(result.msg);
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.getList();
        });
    }
  },
};
</script>

<style lang="less" scoped>
.shuiyang-popover {
  height: 80px;
  font-size: 16px;
  .el-radio-group {
    margin: 20px;
  }
  .btns {
    float: right;
  }
}
</style>
